import close from '../assets/svg-icons/closeBrand.svg';
const Modal = ({ title, isVisible, onClose, size, children }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div className="w-full left-0 z-50 fixed h-screen bg-black/30 top-0 px-4 flex items-end md:items-center justify-center">
      <div
        className={`bg-white dark:bg-[#141D26] rounded w-full ${size ? size : `md:w-[30%]`}  md:mx-auto dark:text-white max-h-[80%] mb-4 md:mb-0 flex flex-col justify-center items-center`}
      >
        <div className="w-full flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
          <span className="dark:text-white">{title}</span>
          <img
            src={close}
            onClick={() => {
              onClose();
            }}
            className="h-5 cursor-pointer"
            alt=""
          />
        </div>
        <div className="grid text-xs px-4 pb-4 pt-2 w-full overflow-y-auto flex-1 min-h-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
